import Accordion from './Accordion.component';

export default Accordion;